import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { roundToDecimal } from "../../../../../../utils/helper/utils";

const SalesByZone = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [paginationModel] = useState(paginationLimit); //setPaginationModel

  const [dataSource, setDataSource] = useState([]);

  const getAllReportsByZone = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_ZONE, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse?.data?.items) {
          let resultData = [];
          for (let key in apiResponse?.data?.items) {
            let item = apiResponse?.data?.items[key];
            resultData.push({
              key: key,
              name: item.zoneName,
              zoneId: item.zoneId,
              TotalOrders: item.orderCount,
              WithoutTax: roundToDecimal(item.totalSubTotal, 2),
              Tax: roundToDecimal(item.totalAmount, 2),
              averageSubTotal: item.averageSubTotal,
              averageTotalAmount: item.averageTotalAmount,
            });
          }
          setDataSource(resultData);
        }
      } else {
        setDataSource([]);
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReportsByZone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
    title: "ID",
    dataIndex: "zoneId",
    key: "zoneId",
    sorter: (a, b) => a.zoneId - b.zoneId,
    render: (text) => text || "-"
  },
    {
      title: "Zone Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Total Orders",
      dataIndex: "TotalOrders",
      key: "TotalOrders",
      render: (text, record) => (
        <Typography
          onClick={() => {
            navigate(`/zone-order/${record?.zoneId}`, { state: { inputData: inputData, tabIndex: tabIndex } });
          }}
          className="cursor-pointer text-[#176B53]"
        >
          {text}
        </Typography>
      ),
    },
    {
      title: "Total Sales with Tax",
      dataIndex: "Tax",
      key: "Tax",
    },
    {
      title: "Total Sales Without Tax",
      dataIndex: "WithoutTax",
      key: "WithoutTax",
    },
  ];

  return <Table columns={columns} dataSource={dataSource} className="multi-tables responsive" />;
};

export default SalesByZone;
